import { render } from "./PaymentBasketStepComponent.vue?vue&type=template&id=2e4089aa&ts=true"
import script from "./PaymentBasketStepComponent?vue&type=script&lang=ts"
export * from "./PaymentBasketStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__